import { createGlobalStyle } from "styled-components";
import { colors } from "constants/colors";

export const GlobalStyle = createGlobalStyle`
	@font-face {
		font-family: "NotoSansKR";
		font-style: normal;
		font-weight: 400;
		src: url('/fonts/NotoSansKR-Regular.woff2') format("woff2"), url('/fonts/NotoSansKR-Regular.woff') format("woff");
	}
	@font-face {
		font-family: "NotoSansKR";
		font-style: normal;
		font-weight: 500;
		src: url('/fonts/NotoSansKR-Medium.woff2') format("woff2"), url('/fonts/NotoSansKR-Medium.woff') format("woff");
	}
	@font-face {
		font-family: "NotoSansKR";
		font-style: normal;
		font-weight: 700;
		src: url('/fonts/NotoSansKR-Bold.woff2') format("woff2"), url('/fonts/NotoSansKR-Bold.woff') format("woff");
	}

	body,
	input,
	select,
	button,
	textarea,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	table,
	pre {
		font-family: "NotoSansKR";
		font-size: 15px;
		font-weight: 400;
		line-height: 23px;
		letter-spacing: -0.75px;
		color: ${colors.black};
	}
	html,
	body,
	div,
	form,
	input,
	select,
	button,
	textarea,
	legend,
	fieldset,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	ul,
	ol,
	dl,
	li,
	dt,
	dd,
	blockquote,
	address,
	p,
	th,
	td,
	caption,
	pre {
		margin: 0;
		padding: 0;
	}
	html,
	body {
		-webkit-text-size-adjust: none;
	}
	ol,
	ul,
	li {
		list-style: none;
	}
	img,
	fieldset {
		border: 0 none;
	}
	input[type="text"],
	input[type="password"],
	input[type="submit"],
	input[type="search"],
	input[type="number"],
	input[type="date"],
	textarea {
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
	}
	button {
		border: 0 none;
		background: rgba(0, 0, 0, 0);
		cursor: pointer;
	}
	img,
	button,
	label,
	input,
	select,
	textarea {
		vertical-align: top;
	}
	legend,
	.hide {
		overflow: hidden;
		width: 0;
		height: 0;
		visibility: hidden;
		font-size: 0;
		line-height: 0;
	}
	table {
		width: 100%;
		border-collapse: collapse;
		border-spacing: 0;
		table-layout: fixed;
	}
	header,
	footer,
	section,
	article,
	aside,
	nav,
	hgroup,
	details,
	menu,
	figure,
	figcaption {
		display: block;
	}
	em,
	address,
	strong {
		font-style: normal;
		font-weight: 400;
	}
	a {
		color: inherit;
		text-decoration: none;
	}
	a:hover {
		text-decoration: none;
	}
	input[type="date"] {
		position: relative;
	}
	input[type="date"]:before {
		position: absolute;
		left: 16px;
		margin: auto;
		content: attr(placeholder);
		color: ${colors.lightGray2};
	}
	input[type="date"].on:before {
		content: "";
	}
`;
